"use client";
import { createContext, useContext, useState } from "react";

type PageType = "default" | "author";

const PageTypeContext = createContext<{
  pageType: PageType;
  setPageType: (t: PageType) => void;
}>({ pageType: "default", setPageType: () => {} });

export function PageTypeProvider({ children }: { children: React.ReactNode }) {
  const [pageType, setPageType] = useState<PageType>("default");
  return (
    <PageTypeContext.Provider value={{ pageType, setPageType }}>
      {children}
    </PageTypeContext.Provider>
  );
}

export const usePageType = () => useContext(PageTypeContext);